export default (state, { payload }) => {
    const image = { src: null, width: null, height: null };

    return {
        ...state,
        referenceImage: {
            ...state.referenceImage,
            image: { ...(payload || image) },
        },
    };
};
